/**
 * 멤버십 갱신 - 화면 확인용 목업 라우트
 * 기획서: 더파르나스멤버십APP_멤버십갱신개발_2606_코멘트(반영)_V0.8.pptx (6p, 7p, 9p ~ 11p)
 *
 * ※ 갱신안내 팝업(5p)은 메인화면에서 `/?renewal=popup` 으로 확인할 수 있습니다.
 */
const renewalRoutes = [
    {
        path: "/renewal-membership",
        name: "RenewalMembership",
        meta: {
            bodyId: "mypage_vc_detail",
            layout: "MainLayout",
            // 수정안 슬라이드 3 의 헤더 문구
            title: "멤버십 선택",
            // 문자 딥링크로 바로 들어올 수 있어 비로그인 진입을 막아야 한다.
            // 경로를 보관하고 /login 으로 보냈다가 로그인 후 복귀시킨다. (utils/deeplink.js)
            requiresAuth: true
        },
        component: () => import("@/views/renewal/RenewalMembership"),
    },
    {
        path: "/renewal-complete",
        name: "RenewalComplete",
        meta: {
            bodyId: "mypage_vc_detail",
            layout: "MainLayout",
            // 결과에 따라 아래 beforeEnter 가 "멤버십 결제 완료/실패" 로 덮어쓴다.
            title: "멤버십 결제",
            // 뒤로가면 히스토리에 남은 PG 결제창(이미 만료됨)으로 돌아가므로 홈으로 보낸다.
            backTo: "/",
            // requiresAuth 를 일부러 걸지 않는다.
            // PG 결제 후 복귀 지점이라 복귀 타이밍에 스토어가 비어 있을 수 있는데,
            // 여기서 /login 으로 튕기면 결제는 됐는데 결과를 못 보는 최악이 된다.
        },
        /*
          헤더 문구를 결제 결과에 맞춘다 (수정안 슬라이드 4).
          컴포넌트가 아니라 여기서 정하는 이유 — Header 는 $route.meta.title 을 그리는데
          라우터의 currentRoute 가 shallowRef 라 **화면 진입 후 meta 를 고치면 다시 그려지지 않는다.**
          진입 전인 이 시점에 바꿔야 첫 렌더부터 맞는 문구가 나온다.
        */
        beforeEnter: (to) => {
            to.meta.title = to.query["is-success"] === "false" ? "멤버십 결제 실패" : "멤버십 결제 완료"
        },
        component: () => import("@/views/renewal/RenewalComplete"),
    },
    {
        path: "/renewal-history",
        name: "RenewalHistory",
        meta: {
            bodyId: "mypage_vc",
            layout: "MainLayout",
            // 수정안 슬라이드 7 의 화면 명칭
            title: "멤버십 결제 내역",
            requiresAuth: true
        },
        component: () => import("@/views/renewal/RenewalHistory"),
    },
    {
        path: "/renewal-history-detail",
        name: "RenewalHistoryDetail",
        meta: {
            bodyId: "mypage_vc_detail",
            layout: "MainLayout",
            title: "결제정보 상세",
            requiresAuth: true
        },
        component: () => import("@/views/renewal/RenewalHistoryDetail"),
    },
]

export default renewalRoutes
